import React from "react";

function NavBar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light nav-bar-color">
      <a className="navbar-brand" href="/">
        Karni Batteries
      </a>
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarNavDropdown">
        {/* <ul className="navbar-nav"> */}
          {/* <li className="nav-item active">
            <a className="nav-link" href="/">
              Home
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link active" href="#main-products">
              Products
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link active" href="#about">
              Contacts
            </a>
          </li> */}
        {/* </ul> */}
      </div>
    </nav>
  );
}

export default NavBar;
